<template>
  <div>
    <right-panel
      class="float-right"
      id="sidebar-new-electronic-archive-category"
      width="800px"
      :icon="'mdi mdi-plus'"
      :text="$t('electronic-archive-category.new')"
      @hidden="rightPanelClosed"
    >
      <div class="pl-5 pr-5">
        <Form :hide-library="true" :closeOnSave="false" />
      </div>
    </right-panel>

    <div>
      <h2>{{ $t("electronic-archive-category.library") }}</h2>
    </div>

    <div class="bg-white">
      <table class="table table-bordered table-striped">
        <!-- -- Contexts -->
        <thead class="bg-secondary text-white">
          <tr>
            <th style="width: 100px">
              <b-dropdown split :text="$t('common.select-all')" class="btn-block" variant="secondary" size="sm" @click="selectAllItems">
                <template #button-content>
                  <b> {{ selectedItems.length > 0 ? $t("common.deselect-all") : $t("common.select-all-items") }}</b>
                </template>

                <b-dropdown-item href="#" @click="multipleDeleteById(selectedItems)" :disabled="!isAtLeastOneItemSelected">
                  <i class="bx bx-trash-alt text-danger" v-b-tooltip.hover :title="$t('common.delete')"></i> {{ $t("common.delete") }} ({{ selectedItems.length }})
                </b-dropdown-item>
              </b-dropdown>
            </th>
            <sortable-table-head field="name.tr" :text="$t('common.name')" :request="request" />
            <th>{{ $t("sector.name") }}</th>
            <th>{{ $t("common.type") }}</th>
            <th>{{ $t("common.created-by") }}</th>
            <th scope="col" style="width: 15%">
              <a href="javascript:;" @click="toggleFilter">
                <span v-if="filterEnabled" class="text-warning">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-hide") }}
                </span>
                <span v-else class="text-white">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-show") }}
                </span>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="filterEnabled">
            <th></th>
            <th><input class="form-control " v-model="nameFilter" /></th>
            <th>
              <filter-select id="sectorFilter" ref="sectorFilter" :placeholder="$t('sector.text')" :multiple="false" @filter="onSectorSearch" @changed="onSectorSelect" />
            </th>
            <th>
              <select class="form-control " v-model="scopeFilter">
                <option :value="undefined">{{ $t("common.all") }}</option>
                <option value="system">{{ $t("common.system") }}</option>
                <option value="workspace">{{ $t("common.workspace") }}</option>
              </select>
            </th>
            <th></th>
            <th></th>
          </tr>

          <template v-if="pagination">
            <!-- -- table data start -->
            <tr v-for="item in pagination.docs" :key="item._id">
              <!-- name -->
              <td>
                <div class="text-center">
                  <b-form-checkbox v-model="selectedItems" :value="item" class="custom-checkbox-primary mb-3 " checked></b-form-checkbox>
                </div>
              </td>
              <td>{{ item.name | translate }}</td>
              <!-- sector -->
              <td>
                <span v-if="item.sector">
                  <span v-if="item.sector.scope.value == 'workspace'" v-b-tooltip.hover>
                    <!-- <i class="text-muted mdi mdi-hexagon-multiple-outline"></i> -->
                  </span>
                  <span v-else v-b-tooltip.hover :title="$t('library.belonging-to-the-system')">
                    <!-- <i class="text-muted mdi mdi-database"></i> -->
                    {{ item.sector.name | translate }}
                  </span>
                </span>
              </td>
              <span v-if="item.scope.value == 'workspace' && item.scope.workspace" v-b-tooltip.hover :title="item.scope.workspace.owner.name + '/' + item.scope.workspace.name">
                <i class="text-muted mdi mdi-hexagon-multiple-outline"></i>
                {{ item.scope.workspace.owner.name + "/" + item.scope.workspace.name }}
              </span>
              <span v-else v-b-tooltip.hover :title="$t('library.belonging-to-the-system')">
                <i class="text-muted mdi mdi-database"></i>
                {{ item.scope.value }}
              </span>
              <!-- created name -->
              <td>{{ item.scope.createdBy.name }}</td>

              <!-- edit -->
              <td>
                <div class="font-size-16 text-center" v-if="selectedItems.length == 0">
                  <i class="bx bx-trash-alt text-danger hand mr-3" v-b-tooltip.hover :title="$t('common.delete')" @click="deleteById(item)"></i>
                  <i class="bx bx-pencil text-primary hand" v-b-tooltip.hover :title="$t('common.edit')" @click="edit(item)"></i>
                </div>
              </td>
            </tr>
            <!-- --table data end -->
          </template>
        </tbody>
      </table>
    </div>

    <b-modal id="modal-multiple-delete-operation" centered :title="$t('common.multiple-delete-operation')" hide-footer>
      <div v-if="deleteOperationResult.success.length > 0">
        <h5 class="text-success">
          {{ $t("common.delete-items") }}
        </h5>

        <ul>
          <li v-for="item in deleteOperationResult.success" :key="item.id">
            {{ item | translate }}
          </li>
        </ul>
      </div>

      <div v-if="deleteOperationResult.failed.length > 0">
        <h5 class="text-danger mt-4">{{ $t("common.delete-failed") }}</h5>
        <ul>
          <li v-for="item in deleteOperationResult.failed" :key="item.id">
            <b> {{ item.name | translate }}</b>
            {{ item.error }}
          </li>
        </ul>
      </div>
    </b-modal>

    <content-loading v-if="loading" />

    <!-- Begin: Pagination -->
    <empty v-if="!loading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center" id="myText">
        {{ $t("electronic-archive-category.no") }}
      </h5>
    </empty>

    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
import Form from "./management-library-electronic-archive-category-form";

const state = "managementElectronicArchiveCategory";

export default {
  components: {
    Form,
  },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { "scope.workspace": "asc" } },
        query: {},
      },
      nameFilter: undefined,
      scopeFilter: undefined,
      filterEnabled: false,
      selectedItems: [],
    };
  },
  watch: {
    request: {
      deep: true,
      immediate: true,

      handler() {
        this.debounce(() => this.init());
      },
    },

    nameFilter(n, o) {
      this.request.query = {
        ...this.request.query,
        name: { value: n },
      };
    },
    scopeFilter(n, o) {
      if (n) {
        this.request.query = {
          ...this.request.query,
          "scope.value": { value: n, isObject: true },
        };
      } else {
        this.request.query["scope.value"] = null;
        delete this.request.query["scope.value"];
      }
    },
  },
  computed: {
    pagination() {
      return this.$store.getters[`${state}/pagination`];
    },
    loading() {
      return this.$store.getters[`${state}/isLoading`];
    },
    deleteOperationResult() {
      return this.$store.getters[`${state}/deleteOperationResult`];
    },
    isAtLeastOneItemSelected() {
      return this.selectedItems.length > 0;
    },
  },
  methods: {
    init() {
      this.$store.dispatch(`${state}/paginate`, this.request);
      this.selectedItems = [];
    },
    rightPanelClosed() {
      this.$store.commit(`${state}/editedEntity`, null);
      this.init();
    },

    edit(item) {
      this.$store.commit(`${state}/editedEntity`, { ...item });
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-electronic-archive-category");
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/delete`, item._id);
        this.init();
        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' " + this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    selectAllItems() {
      if (this.selectedItems.length > 0) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.pagination.docs.slice();
      }
    },

    async multipleDeleteById(selectedItems) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch(`${state}/multipleDelete`, selectedItems);
        this.init();
        this.selectedItems = [];
        this.$root.$emit("bv::show::modal", "modal-multiple-delete-operation");
      } catch (error) {
        console.error(error);
      }
    },
    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },

    async onSectorSearch(value, callback) {
      const response = await this.$store.dispatch(`managementSector/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onSectorSelect(item) {
      if (item && Object.keys(item).length) {
        this.request.query = {
          ...this.request.query,
          sector: { value: item._id, isObject: true },
        };
      } else {
        this.request.query["sector"] = null;
        delete this.request.query["sector"];
      }
    },
  },
};
</script>
